// extracted by mini-css-extract-plugin
export default {"subjects":"subjects_subjects__DBY4n"};